import brandingTokens from '../branding';
import { getTier } from './LocalStorage';

export interface IDataLayer {
	application: string;
	user_id: string;
	user_corp: number;
	user_profile: string;
	tier?: string;
}

export const syscoDataLayer: IDataLayer = {
	application: 'syscoogm',
	user_id: null,
	user_corp: null,
	user_profile: null,
};

export const defaultDataLayer: IDataLayer = {
	application: 'OGM',
	user_id: null,
	user_corp: null,
	user_profile: null,
};

function getDataLayerByApplication(): IDataLayer {
	return brandingTokens.application === 'sysco'
		? syscoDataLayer
		: defaultDataLayer;
}

// We store all gtm info in local storage, which then gets used by the sysco and dssi header cshtml files
export function setDataLayer(dataLayer: IDataLayer) {
	const { application, tier, ...dataLayerWithoutApplication } = dataLayer;
	const gtmData = {
		tier: getTier(),
		...getDataLayerByApplication(),
		...dataLayerWithoutApplication,
	};
	window.localStorage.setItem('ogm.gtm', JSON.stringify(gtmData));
	const gtmDataLayer = (window as any).dataLayer || [];
	gtmDataLayer.push(gtmData);
}

export function getDataLayer(): IDataLayer {
	return JSON.parse(window.localStorage.getItem('ogm.gtm'));
}
